import request from '@/utils/request'

// 查询用户个人信息
export function getUserProfile() {
    return request({
        url: '/system/user/profile/get',
        method: 'get'
    })
}

// 修改用户个人信息
export function updateUserProfile(data) {
    return request({
        url: '/system/user/profile/update',
        method: 'put',
        data: data
    })
}

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
    const data = {
        oldPassword,
        newPassword
    }
    return request({
        url: '/system/user/profile/update-password',
        method: 'put',
        data: data
    })
}

// 发送手机更新的验证码
export function sendMobileCode(mobile,templateCode) {
    const data = {
        mobile,
        templateCode
    }
    return request({
        url: '/yuzhen/update/user/code',
        method: 'post',
        data: data
    })
}

// 更新用户手机号码
export function updateUserMobile(mobile, code) {
    const data = {
        mobile,
        code
    }
    return request({
        url: '/yuzhen/update/user/mobile',
        method: 'post',
        data: data
    })
}

// 发送邮箱更新的验证码
export function sendEmailCode(email) {
    const data = {
        email
    }
    return request({
        url: '/yuzhen/update/user/email/code',
        method: 'post',
        data: data
    })
}

// 更新用户邮箱
export function updateUserEmail(email, code) {
    const data = {
        email,
        code
    }
    return request({
        url: '/yuzhen/update/user/email',
        method: 'post',
        data: data
    })
}
